/**
 * @generated SignedSource<<d01f63ab114d86ea8dcd9509f37b4026>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTopicsByIdsQuery$variables = {
  applicationId: string;
  first?: number | null | undefined;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  topicIds: ReadonlyArray<string>;
};
export type hooksTopicsByIdsQuery$data = {
  readonly topics: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contents: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly entityId: string;
              readonly publishedDate: number | null | undefined;
              readonly " $fragmentSpreads": FragmentRefs<"subscriberContentInlinePlusWidgetContent">;
            };
          }>;
        } | null | undefined;
      };
    }>;
  };
};
export type hooksTopicsByIdsQuery = {
  response: hooksTopicsByIdsQuery$data;
  variables: hooksTopicsByIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicIds"
},
v4 = [
  {
    "kind": "Variable",
    "name": "applicationId",
    "variableName": "applicationId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "topicIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "paywallTypeIds",
        "variableName": "scmpPlusPaywallTypeIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "PUBLISHED_DATE"
    }
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v13 = [
  (v6/*: any*/),
  (v11/*: any*/)
],
v14 = [
  (v6/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v14/*: any*/),
          "type": "Section",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v14/*: any*/),
          "type": "VideoSection",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksTopicsByIdsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "ContentConnection",
                    "kind": "LinkedField",
                    "name": "contents",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "subscriberContentInlinePlusWidgetContent"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hooksTopicsByIdsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "ContentConnection",
                    "kind": "LinkedField",
                    "name": "contents",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isContent"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "headline",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "socialHeadline",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flag",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v10/*: any*/),
                                        "type": "Section",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v10/*: any*/),
                                        "type": "VideoSection",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v11/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Sponsor",
                                    "kind": "LinkedField",
                                    "name": "sponsor",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "images",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlAlias",
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UrlRedirect",
                                    "kind": "LinkedField",
                                    "name": "urlRedirect",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "toUrl",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Application",
                                    "kind": "LinkedField",
                                    "name": "application",
                                    "plural": false,
                                    "selections": (v13/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Section",
                                        "kind": "LinkedField",
                                        "name": "fullSectionPath",
                                        "plural": true,
                                        "selections": (v13/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "parentSection",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "flattenTypeIds",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LiveArticle",
                                        "kind": "LinkedField",
                                        "name": "liveArticle",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "status",
                                            "storageKey": null
                                          },
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SectionSegment",
                                        "kind": "LinkedField",
                                        "name": "sections",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Section",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": (v13/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PaywallType",
                                            "kind": "LinkedField",
                                            "name": "paywallTypes",
                                            "plural": true,
                                            "selections": [
                                              (v12/*: any*/),
                                              (v11/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "Article",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FormattedValue",
                                            "kind": "LinkedField",
                                            "name": "description",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "text",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "types",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sponsorType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v15/*: any*/)
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "03e7362a8af70a61e04054bc30b48681",
    "id": null,
    "metadata": {},
    "name": "hooksTopicsByIdsQuery",
    "operationKind": "query",
    "text": "query hooksTopicsByIdsQuery(\n  $topicIds: [String!]!\n  $applicationId: String!\n  $first: Int = 10\n  $scmpPlusPaywallTypeIds: [String]\n) {\n  topics(filter: {entityIds: $topicIds}, first: $first, applicationId: $applicationId) {\n    edges {\n      node {\n        contents(first: 4, filter: {paywallTypeIds: $scmpPlusPaywallTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n          edges {\n            node {\n              __typename\n              entityId\n              publishedDate\n              ...subscriberContentInlinePlusWidgetContent\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment subscriberContentInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n  ...hooksContentHeadlineTagContent\n  entityId\n  headline\n  socialHeadline\n  urlAlias\n}\n"
  }
};
})();

(node as any).hash = "52bbd74547ed9c82dca1aee11b1d1195";

export default node;
